export default [
    require('./copy').default,
    
]


// WEBPACK FOOTER //
// ./src/directives/index.js